(ns frontend.view.grid.common.no-results-view
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [frontend.view.entity :as f-entity]
   [frontend.state.current-session :as session]
   [ui.components.button.view :as button]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]))

(defn stage-item
  [{:keys [entity-type pipeline]} {:keys [db/id] :as stage}]
  {:key (str "stage-" id)
   :label (entity/display-string stage)
   :on-click
   (fn [_]
     (f-entity/open-creator!
      entity-type
      {:pipeline pipeline
       :ident [:froppo-creator]
       :skip-success-msg? true
       :stage stage}))})

(defn create-dropdown
  [{:keys [entity-type]}]
  (let [selected-pipeline-key (case entity-type
                                :entity.type/fundraising-opportunity
                                :fundraising-opportunity-pipeline

                                :entity.type/oppo
                                :oppo-pipeline

                                :entity.type/sales-opportunity
                                :sales-opportunity-pipeline

                                :entity.type/exit-opportunity
                                :exit-opportunity-pipeline)
        pipeline-id (get @session/selected-pipelines selected-pipeline-key)
        pipeline (session/get-entity pipeline-id)
        stages (->> (session/pipeline-stages pipeline-id)
                    (sort-by :common/ord))]
    [dropdown-menu/view
     {:props {:side "right"}
      :trigger [dropdown-menu/button-trigger
                {:label (loc/tr :grid-no-entities-create-button)
                 :icon [:i.fal.fa-angle-right]
                 :dom-id "grid-create-button"}]
      :items   (for [stage stages]
                 (stage-item {:entity-type entity-type
                              :pipeline pipeline} stage))}]))

(defn legal-entity-item
  [{:keys [entity-type]}]
  {:key (str entity-type)
   :label (loc/tr entity-type)
   :on-click
   (fn [_]
     (f-entity/open-creator!
      :entity.type/investor
      {:legal-entity-type entity-type
       :ident [:investor-creator]
       :skip-success-msg? true}))})

(defn investor-dropdown
  []
  [dropdown-menu/view
   {:props {:side "right"}
    :trigger [dropdown-menu/button-trigger
              {:label (loc/tr :grid-no-entities-create-button)
               :icon [:i.fal.fa-angle-right]
               :dom-id "grid-create-button"}]
    :items   (for [entity-type [:entity.type/person :entity.type/company]]
               (legal-entity-item {:entity-type entity-type}))}])

(defn investor-creation-info
  []
  [:div
   (loc/tr :grid-investor-creation)])

(defn no-entities-view
  [{:keys [entity-type create-fn]}]
  [:div
   {:class "flex flex-col justify-center items-center gap-5"}
   [:img
    {:src "/img/no-result-found.svg"
     :class "max-w-40"}]
   [:strong
    {:class "block text-xl font-medium text-complement-light-text"}
    (loc/tr :grid-no-entities-yet)]
   (when-not (session/is-read-only-user?)
     (cond (let [flow-fn (get f-entity/opportunity-flow-fns entity-type)]
             (and flow-fn (flow-fn)))
           [create-dropdown
            {:entity-type entity-type}]

           (= entity-type :entity.type/investor)
           [investor-dropdown]

           :else
           [button/primary-solid
            {:on-click   (fn [_]
                           (if (fn? create-fn)
                             (create-fn)
                             (f-entity/open-creator! entity-type {})))}
            (loc/tr :grid-no-entities-create-button)]))])

(defn no-entities-found-view []
  [:div
   {:class "py-4 flex flex-col justify-center items-center gap-6 text-center"}
   [:img
    {:src "/img/undraw_No_data_re_kwbl.svg"
     :class "mb-3 max-w-40"}]
   [:strong
    {:class "block text-xl font-medium text-complement-light-text"}
    (loc/tr :grid-no-entities-found)]
   [:span
    {:class "block text-sm font-medium text-complement-light-text"}
    (loc/tr :grid-no-entities-found-info)]])
